import { Injectable } from '@angular/core';
import { PermissionDataModel } from '@osos/shared/api';
import { PermissionsPresenterModel } from '@osos/shared/types';
import { FactoryBase } from '../../bases/factory/factory-base';
import { PermissionsParserV1Service } from '../../parsers/permissions-parser/permissions-parser-v1.service';
import { ParserFactory } from '../../services/parser-factory-service/parser-factory';

@Injectable()
export class PermissionsFactoryService extends FactoryBase<
  PermissionDataModel,
  PermissionsPresenterModel
> {
  constructor(
    parserFactory: ParserFactory,
    parser_v1: PermissionsParserV1Service,
  ) {
    super(parserFactory);
    parserFactory.register(parser_v1);
  }
  createPresenterModel(model: PermissionDataModel): PermissionsPresenterModel {
    const parser = this.getParser(
      PermissionDataModel,
      PermissionsPresenterModel,
      //  model.specificationVersion
    );
    return parser.getPresenterModel(model);
  }
  createDataModel(presenter: PermissionsPresenterModel): PermissionDataModel {
    const parser = this.getParser(
      PermissionDataModel,
      PermissionsPresenterModel,
      presenter.specificationVersion,
    );
    return parser.getDataModel(presenter);
  }
}
